import { render, staticRenderFns } from "./mProject.vue?vue&type=template&id=78fe37dc&scoped=true&"
import script from "./mProject.vue?vue&type=script&lang=js&"
export * from "./mProject.vue?vue&type=script&lang=js&"
import style0 from "./mProject.vue?vue&type=style&index=0&id=78fe37dc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fe37dc",
  null
  
)

export default component.exports